import { render } from "./ContentTestView.vue?vue&type=template&id=b6d713d2"
import script from "./ContentTestView.vue?vue&type=script&lang=js"
export * from "./ContentTestView.vue?vue&type=script&lang=js"

import "./ContentTestView.vue?vue&type=style&index=0&id=b6d713d2&lang=css"
import "./ContentTestView.vue?vue&type=style&index=1&id=b6d713d2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__